<template>
  <section>
    <Feature :title="$t('SUPPLIER_MAINTAIN')" :iconClass="'fa-pencil-square-o'">
      <FormRowTwo
        :fieldNameArr="[$t('RFQ_TYPE') + ': ', $t('STATUS') + ': ', $t('DELTA_PN') + ': ', $t('VENDOR_PN') + ': ']"
        :fieldWidthArr="[362, 362, 362, 362]" :fieldSpanWidthArr="[100, 100, 100, 100]">
        <RadioGroup v-model="rfqType" size="large" slot="a">
          <Radio label="COMPONENT">{{ $t('QUOTATION') }}</Radio>
          <Radio label="TOOLING">{{ $t('TOOLING') }}</Radio>
          <Radio label="RFQ">{{ $t('RFQ') }}</Radio>
        </RadioGroup>
        <Select class="Select" v-model="status" slot="b">
          <Option v-for="(item, index) in statusList" :value="item.description" :key="index">{{ item.description }}
          </Option>
        </Select>
        <Input class="Input" v-model="deltaPn" search :enter-button="$t('MORE')" @on-search="moreDeltaPn" slot="c" />
        <Input class="Input" v-model="vendorPn" search :enter-button="$t('MORE')" @on-search="moreVendorPn" slot="d" />
      </FormRowTwo>
      <ButtonRow>
        <Button type="success" @click="search($event, true)" slot="0">{{ $t('COMMON_TEXT_SEARCH') }}</Button>
        <Button type="info" @click="clear" slot="1">{{ $t('CLEAR') }}</Button>
      </ButtonRow>
    </Feature>
    <Feature v-show="quotationView" :title="$t('DATA_MAINTAIN')" :iconClass="'fa-pencil-square-o'">
      <FormRowTwo :fieldNameArr="[$t('CATEGORY') + ': ']" :fieldWidthArr="[362]" :fieldSpanWidthArr="[100]"
        v-if="showCategory">
        <Select class="Select" v-model="categoryKey" @on-change="changeCategory($event)" :placeholder="$t('CHOOSE')"
          slot="a">
          <Option v-for="(item) in categorys" :value="item.key" :key="item.key">
            {{ item.value }}
          </Option>
        </Select>
      </FormRowTwo>
      <ButtonRow v-if="showCategory">
        <Button v-show="isSelectionList" type="success" @click="open" slot="0" v-if="categoryKey != 'PWB'"> 
          {{ $t('OPEN')}} 
        </Button>
        <Button v-show="rfqType != 'RFQ'" type="primary" @click="download" slot="1">{{ $t('DOWNLOAD') }}</Button>
      </ButtonRow>

      <TablePage v-if="rfqType == 'COMPONENT'" :tableWidth="windowWidth" :columnsList="quotationColumnList"
        :resultList="quotationList" @selection="selection" @selectionCancel="selectionCancel" @selectionAll="selectionAll"
        @selectionCancelAll="selectionCancelAll" :pageObj="pageObj" @changePage="changePage" :canChangeRow="false">
      </TablePage>
      <TablePage v-if="rfqType == 'TOOLING'" :tableWidth="windowWidth" :columnsList="toolingColumnList"
        :resultList="quotationList" @selection="selection" @selectionCancel="selectionCancel" @selectionAll="selectionAll"
        @selectionCancelAll="selectionCancelAll" :pageObj="pageObj" @changePage="changePage" :canChangeRow="false">
      </TablePage>
    </Feature>
    <Feature v-show="rfqType === 'RFQ' && quotationListForRfq.length > 0" :title="'Data'" :iconClass="'fa-pencil-square-o'">
      <Table :columns="quotationRfqColumnList" :data="quotationListForRfq">
        <template slot-scope="{ row, index }" slot="groupKey">
          <a style="color: #46a3ff;" @click="clickGroupKeyForRfq(row)">{{ row.groupId }}</a>
        </template>
      </Table>
      <Row type="flex" justify="space-between">
        <Col type="flex" justify="start">
          {{ $t("COMMON_TEXT_FROM") }} {{ pageObjForRfq.page * pageObjForRfq.pageSize - (pageObjForRfq.pageSize - 1) }} {{ $t("COMMON_TEXT_TO") }}
          <span v-if="pageObjForRfq.totalCount < pageObjForRfq.page * pageObjForRfq.pageSize">{{ pageObjForRfq.totalCount }}</span>
          <span v-else> {{ pageObjForRfq.page * pageObjForRfq.pageSize }}</span>
          {{ $t("COMMON_TEXT_OF") }} {{ pageObjForRfq.totalCount }} {{ $t("COMMON_TEXT_ENTRIES") }}
        </Col>
        <Col type="flex" justify="end">
          <Page :total="pageObjForRfq.totalCount" :page-size="pageObjForRfq.pageSize" :prev-text="$t('COMMON_TEXT_PREV')" :next-text="$t('COMMON_TEXT_NEXT')" @on-change="changePageForRfq">
          </Page>
        </Col>
      </Row>
    </Feature>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="deltaPnModel"
      :title="$t('DELTA_PN_MORE')" @on-ok="confirmDeltaPnModel">
      <Input v-model="deltaPnValue" type="textarea" :rows="10" />
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="vendorPnModel"
      :title="$t('VENDOR_PN_MORE')" @on-ok="confirmVendorPnValue">
      <Input v-model="vendorPnValue" type="textarea" :rows="10" />
    </Modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo } from "@/util/alert"
import { Translate } from "@/util/common"
import GroupTitle from "@/views/default/GroupTitle"
import FormRowTwo from '@/components/FormRowTwo'

export default {
  name: "SupplicerMaintain",
  components: {
    GroupTitle,
    FormRowTwo
  },
  created() {
    const vueInstance = this
    vueInstance.$queryStatusList(vueInstance, 'supplier').then(data => {
      if (data) {
        vueInstance.statusList = data
        if (!vueInstance.getSupplierStatus()) {
          vueInstance.setSupplierStatus(vueInstance.statusList[0].description)
        }
        vueInstance.search(true)
      } else {
        AlertInfo(vueInstance, vueInstance.$t('COMMON_MESSAGE_NOT_AUTH')).then(() => {
        })
        vueInstance.$router.push("/home")
      }
    })
  },
  data() {
    return {
      category: {
        key: "OTHERS",
        value: 'Others',
        url: 'SUPPLIER_OTHERS_MAINTAIN'
      },
      categoryKey: 'OTHERS',
      categorys: [
        {
          key: "OTHERS",
          value: 'Others',
          url: 'SUPPLIER_OTHERS_MAINTAIN'
        }, {
          key: "PWB",
          value: "PWB",
          url: "SUPPLIER_PWB_MAINTAIN"
        }, {
          key: "METAL",
          value: 'Metal Case',
          url: "SUPPLIER_METAL_MAINTAIN"
        }, {
          key: "PLASTIC",
          value: 'Plastic Case',
          url: "SUPPLIER_PLASTIC_MAINTAIN"
        }
      ],
      pageObj: {
        "page": 0,
        "totalPage": 0,
        "totalCount": 0,
        "pageSize": 20
      },
      pageObjForRfq: {
        "page": 0,
        "totalPage": 0,
        "totalCount": 0,
        "pageSize": 20
      },
      deltaPnValue: '',
      vendorPnValue: '',
      deltaPnModel: false,
      vendorPnModel: false,
      statusList: [],
      quotationList: [],
      quotationListForRfq: [],
      clickQuotation: {},
      quotationColumnList: [
        {
          type: 'selection',
          width: 80,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RFQ_TYPE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          render: (h, params) => {
            return h("span", {}, params.row["rfqType"].description)
          },
          width: 110,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('FORM_NO');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "formNo",
          render: (h, params) => {
            return h("a", {
              attrs: { style: "color:#46A3FF" },
              on: {
                click: () => {
                  this.setSupplierQuotationId(params.row.uuid)
                  this.setSupplierFormNo(params.row.formNo)
                  this.setSupplierGroupId("")
                  this.setQuotationList([])
                  if (this.status == "Waiting" && params.row.category && params.row.category != this.categoryKey) {
                    this.$Swal
                      .fire({
                        icon: "info",
                        title: Translate("COMMON_MESSAGE_WARN"),
                        text: 'Select Category(' + this.categoryKey + ') and  Original Category(' + params.row.category + ') are different. Do you want change category?',
                        showCancelButton: true,
                        confirmButtonColor: "#19be6b",
                        cancelButtonColor: "#d33",
                        confirmButtonText: this.$t("COMMON_TEXT_CONFIRM"),
                        cancelButtonText: this.$t("COMMON_TEXT_CANCEL"),
                      })
                      .then((result) => {
                        if (result.isConfirmed) {
                          this.$router.push({ name: this.category.url })
                        }
                      })
                  } else if (this.status == "Processing" || this.status == "Close") {
                    if (params.row.category) {
                      this.$router.push({ name: "SUPPLIER_" + params.row.category + "_MAINTAIN" })
                    } else {
                      this.$router.push({ name: "SUPPLIER_OTHERS_MAINTAIN" })
                    }
                  } else {
                    this.$router.push({ name: this.category.url })
                  }
                },
              },
            }, params.row.formNo)
          },
          width: 200,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CATEGORY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "category",
          width: 80,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('DELTA_PN') + '/' + this.$t('DESCRIPTION')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "deltaPartNoDesc",
          width: 450,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VENDOR_PN')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "vendorPartNo",
          width: 150,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CURRENCY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "currency",
          width: 80,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PLANT_CODE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "plant",
          width: 150,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PENDING_DAYS')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "pendingDay",
          width: 150,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('STATUS')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 150,
          align: "center",
          render(h, params) {
            return h("span", {}, params.row.status.description)
          }
        },
      ],
      toolingColumnList: [
        {
          type: "selection",
          width: 50,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RFQ_TYPE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          render: (h, params) => {
            return h("span", {}, params.row["rfqType"].description + " (" + params.row.toolingQuotationType + ")")
          },
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('FORM_NO')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          render: (h, params) => {
            return h("a", {
              attrs: { style: "color:#46A3FF" },
              on: {
                click: () => {
                  this.setSupplierQuotationId(params.row.uuid)
                  this.setSupplierFormNo(params.row.formNo)
                  this.setSupplierGroupId("")
                  this.setQuotationList([])
                  this.$router.push({ name: "TOOLING_SUPPLIER_DETAIL_MAINTAIN" })
                },
              },
            }, params.row.formNo)
          },
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('TOOLING_ID');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "toolingId",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CURRENCY');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "currency",
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PLANT_CODE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "plant",
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PENDING_DAYS')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "pendingDay",
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('STATUS')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: "center",
          render(h, params) {
            return h("span", {}, params.row.status.description)
          }
        },
      ]
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getSupplierRfqType", "getSupplierStatus", "getSupplierDeltaPn",
      "getSupplierVendorPn", "getWindowsWidth", "getSupplierSelection", "getModalSize"]),
    ...mapActions(["toggleLoading", "setQuotationList", "setSupplierRfqType", "setSupplierStatus",
      "setSupplierDeltaPn", "setSupplierVendorPn", "setSupplierQuotationId", "setSupplierFormNo", "addSupplierSelection",
      "removeSupplierSelection", "setSupplierSelection", "setSupplierGroupId"]),
    changePage(page) {
      this.pageObj.page = page - 1
      this.search(false)
    },
    changePageForRfq(page) {
      const vueInstance = this;
      vueInstance.pageObjForRfq.page = page - 1;
      vueInstance.toggleLoading(true);
      vueInstance.searchRfq(false)
        .then(result => {
          if (result === undefined) {
            return;
          }
          vueInstance.pageObjForRfq = {
            "page": result.number + 1,
            "totalPage": result.totalPages,
            "totalCount": result.totalElements,
            "pageSize": result.size
          };
          vueInstance.quotationListForRfq = result.content;
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    moreDeltaPn() {
      this.deltaPnModel = true
      this.setSupplierDeltaPn("")
    },
    moreVendorPn() {
      this.vendorPnModel = true
      this.setSupplierVendorPn("")
    },
    confirmDeltaPnModel() {
      this.deltaPnValue.split('\n').forEach(a => {
        this.setSupplierDeltaPn(this.getSupplierDeltaPn().concat(a.trim() + ";"))
      })
      this.setSupplierDeltaPn(this.getSupplierDeltaPn().substr(0, this.getSupplierDeltaPn().length - 1))
    },
    confirmVendorPnValue() {
      this.vendorPnValue.split('\n').forEach(a => {
        this.setSupervisorVendorPn(this.getSupervisorVendorPn().concat(a.trim() + ";"))
      })
      this.setSupervisorVendorPn(this.getSupervisorVendorPn().substr(0, this.getSupervisorVendorPn().length - 1))
    },
    search(init) {
      const vueInstance = this
      if (init) {
        vueInstance.pageObj = {
          "page": 0,
          "totalPage": 0,
          "totalCount": 0,
          "pageSize": 20
        }
        vueInstance.setSupplierSelection([])
      }
      if (!vueInstance.getSupplierStatus()) {
        AlertInfo(vueInstance, vueInstance.$t('COMMON_MESSAGE_NOT_AUTH')).then(() => {
        })
        vueInstance.$router.push("/home")
      } else {
        vueInstance.quotationList = []
        if (vueInstance.getSupplierRfqType() == "COMPONENT" || vueInstance.getSupplierRfqType() == "TOOLING") {
          vueInstance.toggleLoading(true)
          vueInstance.$queryQuotationMaster(vueInstance, buildCriteria(vueInstance), "supplier", vueInstance.pageObj).then(data => {
            vueInstance.toggleLoading(false)
            if (data) {
              vueInstance.pageObj = {
                "page": data.page.number + 1,
                "totalPage": data.page.totalPages,
                "totalCount": data.page.totalElements,
                "pageSize": data.page.size
              }
              vueInstance.quotationList = data._embedded.supplierQuotationSearchResourceList
              let selectUuid = []
              vueInstance.getSupplierSelection().forEach(selection => {
                selectUuid.push(selection.uuid)
              })
              vueInstance.quotationList.forEach(quotation => {
                if (selectUuid.includes(quotation.uuid)) {
                  quotation._checked = true
                }
              })
            } else {
              vueInstance.toggleLoading(false)
              vueInstance.$Notice.success({
                title: Translate("COMMON_MESSAGE_INFO"),
                desc: Translate("COMMON_MESSAGE_INFO"),
                render: h => {
                  return h('span', [
                    Translate("COMMON_TEXT_NOTHING")
                  ])
                }
              });
            }
          })
        } else if (vueInstance.getSupplierRfqType() == "RFQ") {
          vueInstance.toggleLoading(true)
          vueInstance.searchRfq(init)
            .then(result => {
              if (result === undefined) {
                vueInstance.$Notice.success({
                  title: Translate("COMMON_MESSAGE_INFO"),
                  desc: Translate("COMMON_MESSAGE_INFO"),
                  render: h => h("span", [Translate("COMMON_TEXT_NOTHING")])
                });
              } else {
                vueInstance.pageObjForRfq = {
                  "page": result.number + 1,
                  "totalPage": result.totalPages,
                  "totalCount": result.totalElements,
                  "pageSize": result.size
                };
                vueInstance.quotationListForRfq = result.content;
              }
            })
            .catch(error => {
              console.error(error);
              AlertError(vueInstance, error)
                .then(() => {});
            })
            .finally(() => {
              vueInstance.toggleLoading(false);
            });
        }
      }
    },
    searchRfq(init) {
      const vueInstance = this;
      if (init) {
        vueInstance.pageObjForRfq = {
          "page": 0,
          "totalPage": 0,
          "totalCount": 0,
          "pageSize": 20
        };
      }
      let queryData = {
        status: vueInstance.statusList.find(status => status.description === vueInstance.getSupplierStatus())["statusViewEnum"],
        deltaPartNos: vueInstance.getSupplierDeltaPn() === "" ? [] : vueInstance.getSupplierDeltaPn().split(";"),
        vendorPartNos: vueInstance.getSupplierVendorPn() === "" ? [] : vueInstance.getSupplierVendorPn().split(";")
      };
      vueInstance.quotationListForRfq = [];
      return vueInstance.$quotationHttp
        .post("/supplier/rfq/search?page=" + vueInstance.pageObjForRfq.page + "&size=" + vueInstance.pageObjForRfq.pageSize, queryData)
        .then(response => {
          if (response.data) {
            return response.data;
          }
        });
    },
    download() {
      if (this.getSupplierRfqType() === 'COMPONENT') {
        this.$downloadExcel(this, "supplier/normal", buildCriteria(this), "")
      } else if (this.getSupplierRfqType() === 'TOOLING') {
        this.$downloadExcel(this, "supplier/tooling", buildCriteria(this), "")
      } else if (this.getSupplierRfqType() === 'RFQ') {
        this.$downloadExcel(this, "supplier/rfq", buildCriteria(this), "")
      }
    },
    clear() {
      this.setSupplierRfqType('COMPONENT')
      this.setSupplierStatus(this.statusList[0].description)
      this.setSupplierDeltaPn('')
      this.setSupplierVendorPn('')
      this.deltaPnValue = ''
      this.vendorPnValue = ''
    },
    selection(selection, row) {
      this.addSupplierSelection(row)
    },
    selectionCancel(selection, row) {
      this.removeSupplierSelection(row)
    },
    selectionAll(selection) {
      let selectUuid = []
      this.getSupplierSelection().forEach(select => {
        selectUuid.push(select.uuid)
      })
      selection.forEach(temp => {
        if (!selectUuid.includes(temp.uuid)) {
          this.addSupplierSelection(temp)
        }
      })
    },
    selectionCancelAll(selection) {
      let selectUuid = []
      this.getSupplierSelection().forEach(select => {
        selectUuid.push(select.uuid)
      })
      this.quotationList.forEach(temp => {
        if (selectUuid.includes(temp.uuid)) {
          this.removeSupplierSelection(temp)
        }
      })
    },
    open() {
      const vueInstance = this
      let selectCategory = ""
      let differentCategory = false
      vueInstance.getSupplierSelection().forEach(quotation => {
        if (!selectCategory || !quotation.category || selectCategory === quotation.category) {
          selectCategory = quotation.category
        } else {
          differentCategory = true
        }
      })

      if (differentCategory) {
        vueInstance.$Swal.fire({
          icon: "info",
          title: Translate("COMMON_MESSAGE_ERROR"),
          text: "You select the items that have different categories",
        })
      } else {
        console.log(selectCategory)
        console.log(this.categoryKey)
        if (vueInstance.status == "Waiting" && selectCategory && selectCategory != vueInstance.categoryKey) {
          vueInstance.$Swal
            .fire({
              icon: "info",
              title: Translate("COMMON_MESSAGE_WARN"),
              text: 'Select Category(' + vueInstance.categoryKey + ') and  Original Category(' + selectCategory + ') are different. Do you want change category?',
              showCancelButton: true,
              confirmButtonColor: "#19be6b",
              cancelButtonColor: "#d33",
              confirmButtonText: vueInstance.$t("COMMON_TEXT_CONFIRM"),
              cancelButtonText: vueInstance.$t("COMMON_TEXT_CANCEL"),
            })
            .then((result) => {
              if (result.isConfirmed) {
                vueInstance.setQuotationList(vueInstance.getSupplierSelection())
                vueInstance.setSupplierQuotationId("")
                vueInstance.setSupplierGroupId("")
                if (vueInstance.getSupplierRfqType() === "COMPONENT") {
                  vueInstance.$router.push({ name: vueInstance.category.url })
                } else if (vueInstance.getSupplierRfqType() === "TOOLING") {
                  vueInstance.$router.push({ name: 'TOOLING_SUPPLIER_DETAIL_MAINTAIN' })
                }
              }
            })
        } else {
          vueInstance.setQuotationList(vueInstance.getSupplierSelection())
          vueInstance.setSupplierQuotationId("")
          vueInstance.setSupplierGroupId("")
          if (vueInstance.getSupplierRfqType() === "COMPONENT") {
            vueInstance.$router.push({ name: vueInstance.category.url })
          } else if (vueInstance.getSupplierRfqType() === "TOOLING") {
            vueInstance.$router.push({ name: 'TOOLING_SUPPLIER_DETAIL_MAINTAIN' })
          }
        }
      }
    },
    changeCategory(key) {
      const vueInstance = this
      vueInstance.category = vueInstance.categorys.find(function (category) {
        return category.key == key
      })
    },
    clickGroupKeyForRfq(row) {
      const vueInstance = this;
      vueInstance.setSupplierGroupId(row.groupId);
      vueInstance.$router.push({
        name: "RFQ_SUPPLIER_DETAIL_MAINTAIN",
        params: {
          status: vueInstance.status
        }
      });
    }
  },
  computed: {
    quotationView() {
      return this.quotationList.length > 0
    },
    isSelectionList() {
      return this.getSupplierSelection().length > 0
    },
    showCategory() {
      return this.status == "Waiting" && this.rfqType == 'COMPONENT'
    },
    rfqType: {
      get() {
        return this.getSupplierRfqType()
      },
      set(value) {
        this.quotationList = []
        this.quotationListForRfq = [];
        return this.setSupplierRfqType(value)
      }
    },
    status: {
      get() {
        return this.getSupplierStatus()
      },
      set(value) {
        this.quotationList = []
        this.quotationListForRfq = [];
        this.setSupplierStatus(value)
      }
    },
    deltaPn: {
      get() {
        return this.getSupplierDeltaPn()
      },
      set(value) {
        this.quotationList = []
        this.quotationListForRfq = [];
        this.setSupplierDeltaPn(value)
      }
    },
    vendorPn: {
      get() {
        return this.getSupplierVendorPn()
      },
      set(value) {
        this.quotationList = []
        this.quotationListForRfq = [];
        this.setSupplierVendorPn(value)
      }
    },
    modalSize() {
      return this.getModalSize()
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    },
    quotationRfqColumnList() {
      return [{
        title: this.$t("GROUP_KEY"),
        align: "center",
        width: 150,
        slot: "groupKey"
      }, {
        title: this.$t("VENDOR_CODE"),
        align: "center",
        width: 150,
        key: "vendorCode"
      }, {
        title: this.$t("OA_VENDOR_NAME"),
        align: "center",
        width: 250,
        key: "vendorName"
      }, {
        title: this.$t("PLANT"),
        align: "center",
        width: 150,
        key: "plant"
      }, {
        title: this.$t("CURRENCY"),
        align: "center",
        width: 150,
        key: "currency"
      }, {
        title: this.$t("CPC_ACCOUNT"),
        align: "center",
        width: 150,
        key: "cpcAccount"
      }, {
        title: this.$t("PENDING_DAYS"),
        align: "center",
        width: 150,
        key: "pendingDay"
      }];
    }
  }
}

function buildCriteria(vueInstance) {
  let deltaPnArray = []
  vueInstance.getSupplierDeltaPn().split(';').forEach(a => {
    deltaPnArray.push(a)
  })

  let vendorPnArray = []
  vueInstance.getSupplierVendorPn().split(';').forEach(a => {
    vendorPnArray.push(a)
  })
  return {
    "rfqType": vueInstance.getSupplierRfqType(),
    "status": vueInstance.statusList.find(status => status.description == vueInstance.getSupplierStatus())['statusViewEnum'],
    "deltaPartNos": vueInstance.getSupplierDeltaPn() == "" ? [] : deltaPnArray,
    "vendorPartNos": vueInstance.getSupplierVendorPn() == "" ? [] : vendorPnArray
  }
}

</script>

<style scoped></style>
